import { inject, Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { GroupApiCallService } from '../group-api-call.service';
import { MarketTypeTableData } from '../../models/group-management.model';
import {
    DetailAttribute,
    PaginationData,
} from '../../../../shared/models/shared.model';

@Injectable({ providedIn: 'root' })
export class MarketTypeGroupService {
    private groupApiCallService = inject(GroupApiCallService);

    private marketTypeGroupAttributes: DetailAttribute[] = [
        {
            label: 'Sports',
            name: 'sports',
            apiName: 'sportId',
            type: 'select',
            placeholder: 'Select a tenant first',
            control: [Validators.required],
            dependency: 'tenantId',
        },
        {
            label: 'Market Types',
            name: 'markettypes',
            apiName: 'marketTypeIds',
            type: 'table',
            placeholder: 'Select a sport first',
            control: [Validators.required],
            dependency: 'sportId',
        },
    ];

    loadGroupAttributes(): DetailAttribute[] {
        return this.marketTypeGroupAttributes;
    }

    loadMarketTypeTableData(
        sportId: number,
        pagination?: PaginationData,
    ): Observable<{ items: MarketTypeTableData[]; totalCount: number }> {
        return this.groupApiCallService.getContentData(
            'markettypes',
            { name: 'sports', parentId: sportId },
            pagination,
        ) as Observable<{ items: MarketTypeTableData[]; totalCount: number }>;
    }
}
